// --- Variant configs per background type ---

export const floatingLinesVariants = [
	{ gradient: ['#e947f5', '#2f4ba2', '#5227FF'] },
	{ gradient: ['#8a3a5a', '#b06080', '#6a2a4a'] },
	{ gradient: ['#1a6a8a', '#3a90b0', '#2a5070'] },
	{ gradient: ['#c04020', '#e08040', '#a03030'] },
	{ gradient: ['#5a6a7a', '#7a8a9a', '#4a5a6a'] },
	{ gradient: ['#6a4a8a', '#9a70b0', '#4a3060'] },
	{ gradient: ['#9a7a50', '#c0a070', '#7a6040'] },
];

export const gradientAnimVariants = [
	{
		bgStart: 'rgb(40,10,80)',
		bgEnd: 'rgb(5,5,30)',
		first: '82,39,255',
		second: '124,255,103',
		third: '255,107,107',
		fourth: '100,80,220',
		fifth: '180,100,255',
		pointer: '140,100,255',
	},
	{
		bgStart: 'rgb(60,20,10)',
		bgEnd: 'rgb(30,8,5)',
		first: '255,106,0',
		second: '238,9,121',
		third: '255,210,0',
		fourth: '200,80,40',
		fifth: '180,60,30',
		pointer: '255,140,60',
	},
	{
		bgStart: 'rgb(20,35,22)',
		bgEnd: 'rgb(10,18,12)',
		first: '122,158,126',
		second: '184,212,163',
		third: '74,107,80',
		fourth: '90,130,100',
		fifth: '60,90,65',
		pointer: '100,150,110',
	},
	{
		bgStart: 'rgb(45,30,20)',
		bgEnd: 'rgb(22,15,10)',
		first: '176,137,104',
		second: '212,163,115',
		third: '139,111,71',
		fourth: '150,110,80',
		fifth: '120,90,60',
		pointer: '180,140,100',
	},
	{
		bgStart: 'rgb(40,25,45)',
		bgEnd: 'rgb(20,12,25)',
		first: '155,126,164',
		second: '212,160,192',
		third: '107,80,112',
		fourth: '130,100,140',
		fifth: '100,70,110',
		pointer: '160,120,150',
	},
	{
		bgStart: 'rgb(8,25,50)',
		bgEnd: 'rgb(5,10,30)',
		first: '14,165,233',
		second: '167,139,250',
		third: '45,212,191',
		fourth: '60,100,200',
		fifth: '80,70,180',
		pointer: '100,180,230',
	},
	{
		bgStart: 'rgb(30,20,45)',
		bgEnd: 'rgb(15,10,25)',
		first: '107,91,138',
		second: '192,132,160',
		third: '74,64,104',
		fourth: '90,70,120',
		fifth: '130,100,150',
		pointer: '120,90,140',
	},
];

export const grainientVariants = [
	{ color1: '#974eb1', color2: '#6242e0', color3: '#c78cf8' },
	{ color1: '#7a2a50', color2: '#5a1a3a', color3: '#a05070' },
	{ color1: '#2a9a70', color2: '#064a36', color3: '#80c0a0' },
	{ color1: '#c05030', color2: '#b8942a', color3: '#a0304a' },
	{ color1: '#6a6060', color2: '#4a4040', color3: '#8a7a7a' },
	{ color1: '#506a80', color2: '#3a5060', color3: '#7a90a0' },
	{ color1: '#8a5a30', color2: '#6a4020', color3: '#a07050' },
];

export const liquidChromeVariants: [number, number, number][] = [
	[0.02, 0.02, 0.15],
	[0.12, 0.04, 0.06],
	[0.03, 0.08, 0.08],
	[0.15, 0.1, 0.02],
	[0.1, 0.1, 0.1],
	[0.1, 0.07, 0.03],
	[0.05, 0.05, 0.07],
];

export const lightPillarVariants = [
	{ topColor: '#5227FF', bottomColor: '#c080d0' },
	{ topColor: '#8a2a40', bottomColor: '#c06080' },
	{ topColor: '#0a7a8a', bottomColor: '#7a6aa0' },
	{ topColor: '#a04010', bottomColor: '#b06a10' },
	{ topColor: '#5a5068', bottomColor: '#7a6a80' },
	{ topColor: '#a07010', bottomColor: '#a04040' },
	{ topColor: '#3060a0', bottomColor: '#9a90c0' },
];

/**
 * Convert hex color to RGB object
 * @param {string} hex - Hex color string (e.g., '#5227FF' or '5227FF')
 * @returns {{ r: number, g: number, b: number }} RGB object with values 0-255
 * @example
 * hexToRgb('#5227FF') // { r: 82, g: 39, b: 255 }
 * hexToRgb('5227FF')  // { r: 82, g: 39, b: 255 }
 */
export function hexToRgb(hex) {
	const value = hex.replace('#', '');
	const r = parseInt(value.slice(0, 2), 16);
	const g = parseInt(value.slice(2, 4), 16);
	const b = parseInt(value.slice(4, 6), 16);
	return { r, g, b };
}

/**
 * Convert RGB values to hex color string
 * @param {number} r - Red value (0-255)
 * @param {number} g - Green value (0-255)
 * @param {number} b - Blue value (0-255)
 * @returns {string} Hex color string with # prefix
 * @example
 * rgbToHex(82, 39, 255) // '#5227FF'
 */
export function rgbToHex(r, g, b) {
	const toHex = (n) => {
		const clamped = Math.max(0, Math.min(255, Math.round(n)));
		return clamped.toString(16).padStart(2, '0');
	};
	return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

/**
 * Helper: Convert RGB to HSL
 */
function rgbToHsl(r, g, b) {
	r /= 255;
	g /= 255;
	b /= 255;
	const max = Math.max(r, g, b);
	const min = Math.min(r, g, b);
	let h = 0;
	let s = 0;
	const l = (max + min) / 2;

	if (max !== min) {
		const d = max - min;
		s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
		switch (max) {
			case r:
				h = ((g - b) / d + (g < b ? 6 : 0)) / 6;
				break;
			case g:
				h = ((b - r) / d + 2) / 6;
				break;
			case b:
				h = ((r - g) / d + 4) / 6;
				break;
		}
	}

	return { h: h * 360, s: s * 100, l: l * 100 };
}

/**
 * Helper: Convert HSL to RGB
 */
function hslToRgb(h, s, l) {
	h /= 360;
	s /= 100;
	l /= 100;

	let r, g, b;

	if (s === 0) {
		r = g = b = l;
	} else {
		const hue2rgb = (p, q, t) => {
			if (t < 0) t += 1;
			if (t > 1) t -= 1;
			if (t < 1 / 6) return p + (q - p) * 6 * t;
			if (t < 1 / 2) return q;
			if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
			return p;
		};

		const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
		const p = 2 * l - q;
		r = hue2rgb(p, q, h + 1 / 3);
		g = hue2rgb(p, q, h);
		b = hue2rgb(p, q, h - 1 / 3);
	}

	return { r: r * 255, g: g * 255, b: b * 255 };
}

/**
 * Generate a variant based on a base hex color and variant type
 * @param {string} hexColor - Base color in hex format (e.g., '#5227FF')
 * @param {string} variantType - Type of variant: 'silk', 'floatingLines', 'gradientAnim', 'grainient', 'liquidChrome', 'lightPillar'
 * @returns {*} Generated variant matching the structure of the specified variant type
 */
export function generateVariant(hexColor, variantType) {
	const rgb = hexToRgb(hexColor);
	const hsl = rgbToHsl(rgb.r, rgb.g, rgb.b);

	switch (variantType) {
		case 'silk':
			// Return the hex color as-is for silk
			return hexColor;

		case 'floating-lines': {
			// Generate 3 gradient colors: lighter, base, darker
			const lighter = hslToRgb(
				hsl.h,
				Math.min(100, hsl.s + 20),
				Math.min(100, hsl.l + 15)
			);
			const accent = hslToRgb((hsl.h + 30) % 360, hsl.s, hsl.l);

			return {
				gradient: [
					rgbToHex(lighter.r, lighter.g, lighter.b),
					rgbToHex(accent.r, accent.g, accent.b),
					hexColor,
				],
			};
		}

		case 'gradient': {
			// Generate background colors (darker versions) and accent colors
			const bgStartRgb = hslToRgb(
				hsl.h,
				Math.max(0, hsl.s - 20),
				Math.max(0, hsl.l - 40)
			);
			const bgEndRgb = hslToRgb(hsl.h, Math.max(0, hsl.s - 30), Math.max(0, hsl.l - 60));

			const first = `${Math.round(rgb.r)},${Math.round(rgb.g)},${Math.round(rgb.b)}`;
			const secondRgb = hslToRgb(
				(hsl.h + 60) % 360,
				Math.min(100, hsl.s + 10),
				Math.min(100, hsl.l + 10)
			);
			const thirdRgb = hslToRgb((hsl.h + 120) % 360, hsl.s, hsl.l);
			const fourthRgb = hslToRgb(hsl.h, Math.max(0, hsl.s - 15), Math.max(0, hsl.l - 10));
			const fifthRgb = hslToRgb((hsl.h + 30) % 360, hsl.s, hsl.l);
			const pointerRgb = hslToRgb(hsl.h, hsl.s, Math.min(100, hsl.l + 5));

			return {
				bgStart: `rgb(${Math.round(bgStartRgb.r)},${Math.round(
					bgStartRgb.g
				)},${Math.round(bgStartRgb.b)})`,
				bgEnd: `rgb(${Math.round(bgEndRgb.r)},${Math.round(bgEndRgb.g)},${Math.round(
					bgEndRgb.b
				)})`,
				first,
				second: `${Math.round(secondRgb.r)},${Math.round(secondRgb.g)},${Math.round(
					secondRgb.b
				)}`,
				third: `${Math.round(thirdRgb.r)},${Math.round(thirdRgb.g)},${Math.round(
					thirdRgb.b
				)}`,
				fourth: `${Math.round(fourthRgb.r)},${Math.round(fourthRgb.g)},${Math.round(
					fourthRgb.b
				)}`,
				fifth: `${Math.round(fifthRgb.r)},${Math.round(fifthRgb.g)},${Math.round(
					fifthRgb.b
				)}`,
				pointer: `${Math.round(pointerRgb.r)},${Math.round(pointerRgb.g)},${Math.round(
					pointerRgb.b
				)}`,
			};
		}

		case 'grain-effect': {
			// Generate 3 related colors
			const color1 = hexColor;
			const color2Rgb = hslToRgb(
				(hsl.h + 40) % 360,
				Math.max(0, hsl.s - 20),
				Math.max(0, hsl.l - 15)
			);
			const color3Rgb = hslToRgb(
				hsl.h,
				Math.min(100, hsl.s + 15),
				Math.min(100, hsl.l + 20)
			);

			return {
				color1,
				color2: rgbToHex(color2Rgb.r, color2Rgb.g, color2Rgb.b),
				color3: rgbToHex(color3Rgb.r, color3Rgb.g, color3Rgb.b),
			};
		}

		case 'liquid-chrome': {
			// Convert to normalized RGB values (0-1 range)
			// Scale down to create subtle variations
			return [(rgb.r / 255) * 0.15, (rgb.g / 255) * 0.15, (rgb.b / 255) * 0.15];
		}

		case 'light-pillar': {
			// Generate top color (base) and bottom color (lighter/shifted hue)
			const bottomRgb = hslToRgb(
				(hsl.h + 20) % 360,
				Math.max(0, hsl.s - 10),
				Math.min(100, hsl.l + 25)
			);

			return {
				topColor: hexColor,
				bottomColor: rgbToHex(bottomRgb.r, bottomRgb.g, bottomRgb.b),
			};
		}

		default:
			throw new Error(`Unknown variant type: ${variantType}`);
	}
}
